module.exports = __webpack_public_path__ + "img/o.627a0b0b.svg";